var map = {
	"./address.svg": 89942,
	"./arrow-down.svg": 23284,
	"./arrow-right.svg": 53156,
	"./back.svg": 19065,
	"./badge/rank.svg": 33082,
	"./booking/booking-message-inactive.svg": 66343,
	"./booking/dollar-square.svg": 67180,
	"./booking/messages.svg": 15688,
	"./booking/note.svg": 63712,
	"./booking/profile-2-user.svg": 45718,
	"./booking/star.svg": 61764,
	"./booking/trash.svg": 91596,
	"./booking/wallet-2.svg": 92866,
	"./calendar.svg": 59222,
	"./call.svg": 20588,
	"./cancel.svg": 61386,
	"./cart.svg": 99178,
	"./category/category-gym.svg": 18987,
	"./category/category-life-coach.svg": 11563,
	"./category/category-massage.svg": 64051,
	"./category/category-salon.svg": 63033,
	"./category/category-spa.svg": 72216,
	"./category/category-tham-my.svg": 911,
	"./category/category-toc.svg": 78460,
	"./category/category-workshop.svg": 38279,
	"./check.svg": 74938,
	"./crown-outline.svg": 93950,
	"./crown.svg": 11623,
	"./details.svg": 3356,
	"./edit-profile.svg": 27844,
	"./empty-noti.svg": 73132,
	"./empty-voucher.svg": 5016,
	"./explore.svg": 42935,
	"./exu.svg": 50214,
	"./facility/air-conditioner-active.svg": 76572,
	"./facility/air-conditioner.svg": 30191,
	"./facility/appointment-active.svg": 76646,
	"./facility/appointment.svg": 17605,
	"./facility/cloud-active.svg": 70518,
	"./facility/cloud.svg": 37141,
	"./facility/files-and-folders-active.svg": 34908,
	"./facility/files-and-folders.svg": 73871,
	"./facility/food-and-restaurant-active.svg": 99391,
	"./facility/food-and-restaurant.svg": 91238,
	"./facility/invest-active.svg": 89808,
	"./facility/invest.svg": 33115,
	"./facility/lock-active.svg": 69618,
	"./facility/lock.svg": 20905,
	"./facility/male-female-active.svg": 3427,
	"./facility/male-female.svg": 65794,
	"./facility/man-active.svg": 72915,
	"./facility/man.svg": 59794,
	"./facility/membership-active.svg": 37857,
	"./facility/membership.svg": 92772,
	"./facility/momo-active.svg": 52993,
	"./facility/momo.svg": 14788,
	"./facility/no-tip-active.svg": 57046,
	"./facility/no-tip.svg": 7381,
	"./facility/parking-lot-active.svg": 60481,
	"./facility/parking-lot.svg": 14564,
	"./facility/scooter-active.svg": 75760,
	"./facility/scooter.svg": 37083,
	"./facility/tip-active.svg": 60546,
	"./facility/tip.svg": 3961,
	"./facility/viettel-pay-active.svg": 54449,
	"./facility/viettel-pay.svg": 57012,
	"./facility/wifi-active.svg": 66172,
	"./facility/wifi.svg": 67215,
	"./facility/woman-active.svg": 44065,
	"./facility/woman.svg": 28260,
	"./facility/zalo-pay-active.svg": 46666,
	"./facility/zalo-pay.svg": 81681,
	"./filter.svg": 35250,
	"./google-icon.svg": 33683,
	"./heart-active.svg": 2543,
	"./heart.svg": 1238,
	"./home.svg": 99869,
	"./location.svg": 22657,
	"./logo.svg": 73361,
	"./map.svg": 98124,
	"./message-edit.svg": 23606,
	"./message.svg": 83779,
	"./minus.svg": 25758,
	"./more.svg": 3215,
	"./payment/atm.svg": 95805,
	"./payment/momo.svg": 88597,
	"./payment/visa.svg": 71282,
	"./phone.svg": 88326,
	"./plus-picker.svg": 20817,
	"./plus.svg": 18064,
	"./profile-2user.svg": 44221,
	"./profile/building.svg": 90790,
	"./profile/camera.svg": 95835,
	"./profile/headphone.svg": 85642,
	"./profile/login.svg": 2503,
	"./profile/logout.svg": 42040,
	"./profile/note-text.svg": 45132,
	"./profile/people.svg": 83563,
	"./profile/profile-delete.svg": 47795,
	"./profile/shop-add.svg": 63348,
	"./profile/video-time.svg": 87479,
	"./profile/wallet-2-solid.svg": 77926,
	"./radio-checked.svg": 20539,
	"./radio-unchecked.svg": 80752,
	"./receipt.svg": 33658,
	"./review/emoji-bad.svg": 87845,
	"./review/emoji-good.svg": 75989,
	"./review/emoji-happy-1.svg": 76584,
	"./review/emoji-happy.svg": 18966,
	"./review/emoji-no-emo.svg": 40581,
	"./sale.svg": 87189,
	"./speaker.svg": 4029,
	"./splash/splash-coach.svg": 83318,
	"./splash/splash-gym.svg": 25901,
	"./splash/splash-massage.svg": 32301,
	"./splash/splash-mi-mong.svg": 14570,
	"./splash/splash-spa.svg": 13866,
	"./splash/splash-tham-my.svg": 59277,
	"./splash/splash-toc.svg": 34698,
	"./splash/splash-workshop.svg": 14601,
	"./sun-fog-outline.svg": 28890,
	"./sun-fog.svg": 26843,
	"./tab-menu/calendar-active.svg": 74339,
	"./tab-menu/calendar-inactive.svg": 44566,
	"./tab-menu/chart-active.svg": 51767,
	"./tab-menu/chart-inactive.svg": 25202,
	"./tab-menu/home-active.svg": 94154,
	"./tab-menu/home-inactive.svg": 30539,
	"./tab-menu/message-active.svg": 82500,
	"./tab-menu/message-active_backup.svg": 92491,
	"./tab-menu/message-inactive.svg": 27833,
	"./tab-menu/notification-active.svg": 76078,
	"./tab-menu/notification-inactive.svg": 92951,
	"./tab-menu/profile-active.svg": 1486,
	"./tab-menu/profile-active_backup.svg": 17505,
	"./tab-menu/profile-inactive.svg": 96119,
	"./tab-menu/search-active.svg": 84637,
	"./tab-menu/search-inactive.svg": 82516,
	"./tab-menu/ticket-discount-active.svg": 99007,
	"./tab-menu/ticket-discount-inactive.svg": 50458,
	"./tag.svg": 65606,
	"./time.svg": 56467,
	"./total-booking-left.svg": 85714,
	"./total-booking-right.svg": 49439,
	"./voucher/bookmark-active.svg": 13202,
	"./voucher/bookmark.svg": 27049,
	"./warning.svg": 75530,
	"gstyles/styleguide/icons/svgs/address.svg": 89942,
	"gstyles/styleguide/icons/svgs/arrow-down.svg": 23284,
	"gstyles/styleguide/icons/svgs/arrow-right.svg": 53156,
	"gstyles/styleguide/icons/svgs/back.svg": 19065,
	"gstyles/styleguide/icons/svgs/badge/rank.svg": 33082,
	"gstyles/styleguide/icons/svgs/booking/booking-message-inactive.svg": 66343,
	"gstyles/styleguide/icons/svgs/booking/dollar-square.svg": 67180,
	"gstyles/styleguide/icons/svgs/booking/messages.svg": 15688,
	"gstyles/styleguide/icons/svgs/booking/note.svg": 63712,
	"gstyles/styleguide/icons/svgs/booking/profile-2-user.svg": 45718,
	"gstyles/styleguide/icons/svgs/booking/star.svg": 61764,
	"gstyles/styleguide/icons/svgs/booking/trash.svg": 91596,
	"gstyles/styleguide/icons/svgs/booking/wallet-2.svg": 92866,
	"gstyles/styleguide/icons/svgs/calendar.svg": 59222,
	"gstyles/styleguide/icons/svgs/call.svg": 20588,
	"gstyles/styleguide/icons/svgs/cancel.svg": 61386,
	"gstyles/styleguide/icons/svgs/cart.svg": 99178,
	"gstyles/styleguide/icons/svgs/category/category-gym.svg": 18987,
	"gstyles/styleguide/icons/svgs/category/category-life-coach.svg": 11563,
	"gstyles/styleguide/icons/svgs/category/category-massage.svg": 64051,
	"gstyles/styleguide/icons/svgs/category/category-salon.svg": 63033,
	"gstyles/styleguide/icons/svgs/category/category-spa.svg": 72216,
	"gstyles/styleguide/icons/svgs/category/category-tham-my.svg": 911,
	"gstyles/styleguide/icons/svgs/category/category-toc.svg": 78460,
	"gstyles/styleguide/icons/svgs/category/category-workshop.svg": 38279,
	"gstyles/styleguide/icons/svgs/check.svg": 74938,
	"gstyles/styleguide/icons/svgs/crown-outline.svg": 93950,
	"gstyles/styleguide/icons/svgs/crown.svg": 11623,
	"gstyles/styleguide/icons/svgs/details.svg": 3356,
	"gstyles/styleguide/icons/svgs/edit-profile.svg": 27844,
	"gstyles/styleguide/icons/svgs/empty-noti.svg": 73132,
	"gstyles/styleguide/icons/svgs/empty-voucher.svg": 5016,
	"gstyles/styleguide/icons/svgs/explore.svg": 42935,
	"gstyles/styleguide/icons/svgs/exu.svg": 50214,
	"gstyles/styleguide/icons/svgs/facility/air-conditioner-active.svg": 76572,
	"gstyles/styleguide/icons/svgs/facility/air-conditioner.svg": 30191,
	"gstyles/styleguide/icons/svgs/facility/appointment-active.svg": 76646,
	"gstyles/styleguide/icons/svgs/facility/appointment.svg": 17605,
	"gstyles/styleguide/icons/svgs/facility/cloud-active.svg": 70518,
	"gstyles/styleguide/icons/svgs/facility/cloud.svg": 37141,
	"gstyles/styleguide/icons/svgs/facility/files-and-folders-active.svg": 34908,
	"gstyles/styleguide/icons/svgs/facility/files-and-folders.svg": 73871,
	"gstyles/styleguide/icons/svgs/facility/food-and-restaurant-active.svg": 99391,
	"gstyles/styleguide/icons/svgs/facility/food-and-restaurant.svg": 91238,
	"gstyles/styleguide/icons/svgs/facility/invest-active.svg": 89808,
	"gstyles/styleguide/icons/svgs/facility/invest.svg": 33115,
	"gstyles/styleguide/icons/svgs/facility/lock-active.svg": 69618,
	"gstyles/styleguide/icons/svgs/facility/lock.svg": 20905,
	"gstyles/styleguide/icons/svgs/facility/male-female-active.svg": 3427,
	"gstyles/styleguide/icons/svgs/facility/male-female.svg": 65794,
	"gstyles/styleguide/icons/svgs/facility/man-active.svg": 72915,
	"gstyles/styleguide/icons/svgs/facility/man.svg": 59794,
	"gstyles/styleguide/icons/svgs/facility/membership-active.svg": 37857,
	"gstyles/styleguide/icons/svgs/facility/membership.svg": 92772,
	"gstyles/styleguide/icons/svgs/facility/momo-active.svg": 52993,
	"gstyles/styleguide/icons/svgs/facility/momo.svg": 14788,
	"gstyles/styleguide/icons/svgs/facility/no-tip-active.svg": 57046,
	"gstyles/styleguide/icons/svgs/facility/no-tip.svg": 7381,
	"gstyles/styleguide/icons/svgs/facility/parking-lot-active.svg": 60481,
	"gstyles/styleguide/icons/svgs/facility/parking-lot.svg": 14564,
	"gstyles/styleguide/icons/svgs/facility/scooter-active.svg": 75760,
	"gstyles/styleguide/icons/svgs/facility/scooter.svg": 37083,
	"gstyles/styleguide/icons/svgs/facility/tip-active.svg": 60546,
	"gstyles/styleguide/icons/svgs/facility/tip.svg": 3961,
	"gstyles/styleguide/icons/svgs/facility/viettel-pay-active.svg": 54449,
	"gstyles/styleguide/icons/svgs/facility/viettel-pay.svg": 57012,
	"gstyles/styleguide/icons/svgs/facility/wifi-active.svg": 66172,
	"gstyles/styleguide/icons/svgs/facility/wifi.svg": 67215,
	"gstyles/styleguide/icons/svgs/facility/woman-active.svg": 44065,
	"gstyles/styleguide/icons/svgs/facility/woman.svg": 28260,
	"gstyles/styleguide/icons/svgs/facility/zalo-pay-active.svg": 46666,
	"gstyles/styleguide/icons/svgs/facility/zalo-pay.svg": 81681,
	"gstyles/styleguide/icons/svgs/filter.svg": 35250,
	"gstyles/styleguide/icons/svgs/google-icon.svg": 33683,
	"gstyles/styleguide/icons/svgs/heart-active.svg": 2543,
	"gstyles/styleguide/icons/svgs/heart.svg": 1238,
	"gstyles/styleguide/icons/svgs/home.svg": 99869,
	"gstyles/styleguide/icons/svgs/location.svg": 22657,
	"gstyles/styleguide/icons/svgs/logo.svg": 73361,
	"gstyles/styleguide/icons/svgs/map.svg": 98124,
	"gstyles/styleguide/icons/svgs/message-edit.svg": 23606,
	"gstyles/styleguide/icons/svgs/message.svg": 83779,
	"gstyles/styleguide/icons/svgs/minus.svg": 25758,
	"gstyles/styleguide/icons/svgs/more.svg": 3215,
	"gstyles/styleguide/icons/svgs/payment/atm.svg": 95805,
	"gstyles/styleguide/icons/svgs/payment/momo.svg": 88597,
	"gstyles/styleguide/icons/svgs/payment/visa.svg": 71282,
	"gstyles/styleguide/icons/svgs/phone.svg": 88326,
	"gstyles/styleguide/icons/svgs/plus-picker.svg": 20817,
	"gstyles/styleguide/icons/svgs/plus.svg": 18064,
	"gstyles/styleguide/icons/svgs/profile-2user.svg": 44221,
	"gstyles/styleguide/icons/svgs/profile/building.svg": 90790,
	"gstyles/styleguide/icons/svgs/profile/camera.svg": 95835,
	"gstyles/styleguide/icons/svgs/profile/headphone.svg": 85642,
	"gstyles/styleguide/icons/svgs/profile/login.svg": 2503,
	"gstyles/styleguide/icons/svgs/profile/logout.svg": 42040,
	"gstyles/styleguide/icons/svgs/profile/note-text.svg": 45132,
	"gstyles/styleguide/icons/svgs/profile/people.svg": 83563,
	"gstyles/styleguide/icons/svgs/profile/profile-delete.svg": 47795,
	"gstyles/styleguide/icons/svgs/profile/shop-add.svg": 63348,
	"gstyles/styleguide/icons/svgs/profile/video-time.svg": 87479,
	"gstyles/styleguide/icons/svgs/profile/wallet-2-solid.svg": 77926,
	"gstyles/styleguide/icons/svgs/radio-checked.svg": 20539,
	"gstyles/styleguide/icons/svgs/radio-unchecked.svg": 80752,
	"gstyles/styleguide/icons/svgs/receipt.svg": 33658,
	"gstyles/styleguide/icons/svgs/review/emoji-bad.svg": 87845,
	"gstyles/styleguide/icons/svgs/review/emoji-good.svg": 75989,
	"gstyles/styleguide/icons/svgs/review/emoji-happy-1.svg": 76584,
	"gstyles/styleguide/icons/svgs/review/emoji-happy.svg": 18966,
	"gstyles/styleguide/icons/svgs/review/emoji-no-emo.svg": 40581,
	"gstyles/styleguide/icons/svgs/sale.svg": 87189,
	"gstyles/styleguide/icons/svgs/speaker.svg": 4029,
	"gstyles/styleguide/icons/svgs/splash/splash-coach.svg": 83318,
	"gstyles/styleguide/icons/svgs/splash/splash-gym.svg": 25901,
	"gstyles/styleguide/icons/svgs/splash/splash-massage.svg": 32301,
	"gstyles/styleguide/icons/svgs/splash/splash-mi-mong.svg": 14570,
	"gstyles/styleguide/icons/svgs/splash/splash-spa.svg": 13866,
	"gstyles/styleguide/icons/svgs/splash/splash-tham-my.svg": 59277,
	"gstyles/styleguide/icons/svgs/splash/splash-toc.svg": 34698,
	"gstyles/styleguide/icons/svgs/splash/splash-workshop.svg": 14601,
	"gstyles/styleguide/icons/svgs/sun-fog-outline.svg": 28890,
	"gstyles/styleguide/icons/svgs/sun-fog.svg": 26843,
	"gstyles/styleguide/icons/svgs/tab-menu/calendar-active.svg": 74339,
	"gstyles/styleguide/icons/svgs/tab-menu/calendar-inactive.svg": 44566,
	"gstyles/styleguide/icons/svgs/tab-menu/chart-active.svg": 51767,
	"gstyles/styleguide/icons/svgs/tab-menu/chart-inactive.svg": 25202,
	"gstyles/styleguide/icons/svgs/tab-menu/home-active.svg": 94154,
	"gstyles/styleguide/icons/svgs/tab-menu/home-inactive.svg": 30539,
	"gstyles/styleguide/icons/svgs/tab-menu/message-active.svg": 82500,
	"gstyles/styleguide/icons/svgs/tab-menu/message-active_backup.svg": 92491,
	"gstyles/styleguide/icons/svgs/tab-menu/message-inactive.svg": 27833,
	"gstyles/styleguide/icons/svgs/tab-menu/notification-active.svg": 76078,
	"gstyles/styleguide/icons/svgs/tab-menu/notification-inactive.svg": 92951,
	"gstyles/styleguide/icons/svgs/tab-menu/profile-active.svg": 1486,
	"gstyles/styleguide/icons/svgs/tab-menu/profile-active_backup.svg": 17505,
	"gstyles/styleguide/icons/svgs/tab-menu/profile-inactive.svg": 96119,
	"gstyles/styleguide/icons/svgs/tab-menu/search-active.svg": 84637,
	"gstyles/styleguide/icons/svgs/tab-menu/search-inactive.svg": 82516,
	"gstyles/styleguide/icons/svgs/tab-menu/ticket-discount-active.svg": 99007,
	"gstyles/styleguide/icons/svgs/tab-menu/ticket-discount-inactive.svg": 50458,
	"gstyles/styleguide/icons/svgs/tag.svg": 65606,
	"gstyles/styleguide/icons/svgs/time.svg": 56467,
	"gstyles/styleguide/icons/svgs/total-booking-left.svg": 85714,
	"gstyles/styleguide/icons/svgs/total-booking-right.svg": 49439,
	"gstyles/styleguide/icons/svgs/voucher/bookmark-active.svg": 13202,
	"gstyles/styleguide/icons/svgs/voucher/bookmark.svg": 27049,
	"gstyles/styleguide/icons/svgs/warning.svg": 75530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69211;